'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { PLAN_ENUM, useCreditInfo } from '@/entities/credit';
import { useConfirm } from '@/shared/ui';
import { VAETKI_PRICING_URL } from './consts';

/**
 * 크레딧 부족 다이얼로그를 띄우는 단일 진입점.
 *
 * - useGnbCredit 의 socket(notification:credit) 리스너
 * - 모달 mutation catch 블록의 HTTP 402 분기
 *
 * 둘 모두 이 훅의 openDialog 를 호출한다. 동기(HTTP 402)/비동기(socket) 실패는
 * mutually exclusive (POST 가 402 면 작업 큐 등록조차 안 됨)이므로 중복 호출 가드는 두지 않는다.
 */
export const useNotEnoughCreditDialog = () => {
  const $ = _c(6);
  const {
    data
  } = useCreditInfo();
  const {
    open: openConfirm,
    close: closeConfirm
  } = useConfirm();
  let t0;
  if ($[0] !== closeConfirm || $[1] !== data.plan || $[2] !== openConfirm) {
    t0 = async () => {
      const isProPlus = data.plan === PLAN_ENUM.PRO_PLUS;
      const message = isProPlus ? {
        title: "\uBCF4\uC720 \uD06C\uB808\uB527\uC774 \uBD80\uC871\uD569\uB2C8\uB2E4.",
        content: "\uB2E4\uC74C \uAC31\uC2E0\uC77C\uC5D0 \uD06C\uB808\uB527\uC774 \uB2E4\uC2DC \uCDA9\uC804\uB429\uB2C8\uB2E4.",
        actionButtonText: "\uD655\uC778"
      } : {
        title: "\uBCF4\uC720 \uD06C\uB808\uB527\uC774 \uBD80\uC871\uD569\uB2C8\uB2E4.",
        content: "\uD50C\uB79C \uC5C5\uADF8\uB808\uC774\uB4DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574\uC8FC\uC138\uC694.",
        actionButtonText: "\uC5C5\uADF8\uB808\uC774\uB4DC",
        cancelButtonText: "\uCDE8\uC18C"
      };
      const result = await openConfirm({
        ...message,
        width: "400"
      });
      if (!result) {
        return;
      }
      if (isProPlus) {
        closeConfirm();
      } else {
        window.open(VAETKI_PRICING_URL, "_blank", "noopener,noreferrer");
      }
    };
    $[0] = closeConfirm;
    $[1] = data.plan;
    $[2] = openConfirm;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const openDialog = t0;
  let t1;
  if ($[4] !== openDialog) {
    t1 = {
      openDialog
    };
    $[4] = openDialog;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};